import { isRestfulAction } from '../../../core/store/actions/base-actions';
import { Field } from '../field/field.model';
import { SyncUpItemHelper } from '../sync-up-item/sync-up-item.helper';
import * as actions from './job.actions';
import { Job } from './job.model';
import { State } from './job.reducer';
import { handleFieldValue } from './job.reducer.helpers';

export const submitReducer = (
    action: actions.SubmitAction,
    state: State
): State => {
    const job = action.payload;
    const oldJob = state.entities[job.id];
    let newState;

    // when the job does not exist
    if (!oldJob) {
        newState = {
            ...state,
            ids: [...state.ids, job.id],
            entities: {
                ...state.entities,
                [job.id]: new Job({
                    ...job,
                    fields: job.fields.map(handleFieldValue)
                })
            }
        };
    } else {

        newState = {
            ...state,
            entities: {
                ...state.entities,
                [job.id]: new Job({
                    ...job,
                    dirty: true,
                    fields: job.fields
                        .map(f => handleFieldValue(f, {dirty: true}))
                })
            }
        };
    }

    // run change detection
    if (isRestfulAction(action)) {
        const oldFields = oldJob ? oldJob.fields : [];
        const oldFieldMap: Map<string, Field> = new Map();
        oldFields.forEach(f => oldFieldMap.set(f.id, f));

        if (!oldJob || (oldJob && action.payload.version === oldJob.version)) {
            action.changeQItem = SyncUpItemHelper.getChangeItem(
                action.entity,
                action.payload.modifiedBy,
                job,
                oldJob
            );
        }

        action.changeQItems = [];

        job.fields
            .forEach(field => {

                const oldField = oldFieldMap.get(field.id);

                if (!oldField || (oldField && field.version === oldField.version)) {
                    const item = SyncUpItemHelper.getChangeItem(
                        'field',
                        field.modifiedBy,
                        field,
                        oldFields.find(f => f.id === field.id)
                    );

                    if (!item) {
                        return;
                    }

                    action.changeQItems.push(item);
                }
            });
    }

    return newState;
};



// WEBPACK FOOTER //
// ./src/vas/business-objects/job/job.submit.reducer.ts